import { Outlet } from "react-router-dom";
import CandidateSideBar from "../components/Common/CandidateSideBar";
import NavBar from "../components/Common/NavBar";
import { ThemeProvider } from "@mui/material/styles";
import { defaultRootTheme } from "../utils/theme";

function CandidateDashboardLayout() {
  return (
    <ThemeProvider theme={defaultRootTheme}>
      <div className="flex h-screen">
        <CandidateSideBar />
        <div className="flex w-full flex-col overflow-y-hidden bg-[#F7FAFC]">
          <NavBar />
          <div className="add-scroll p-6 pb-16">
            <Outlet />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default CandidateDashboardLayout;
